module.exports = __webpack_public_path__ + "img/fast_logo2.7ae4a6e5.png";